import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QueryOperatorTypeString } from 'src/app/shared/interfaces/graphql.interface';

@Component({
  selector: 'filter-item-config',
  templateUrl: './filter-item-config.component.html',
})
export class FilterItemConfigComponent implements OnInit {
  @Input() defaultOperator?: QueryOperatorTypeString;
  @Input() operators?: QueryOperatorTypeString[];

  @Output() operatorSelect = new EventEmitter<QueryOperatorTypeString>();

  operatorsFiltred: QueryOperator[];
  operatorValue: QueryOperatorTypeString;

  private readonly _operators: QueryOperator[] = [
    {
      caption: 'Contains',
      key: 'contains',
    },
    {
      caption: 'Not Contains',
      key: 'ncontains',
    },
    {
      caption: 'Starts With',
      key: 'startsWith',
    },
    {
      caption: 'Not Starts With',
      key: 'nstartsWith',
    },
    {
      caption: 'Equal',
      key: 'eq',
    },
    {
      caption: 'Not Equal',
      key: 'neq',
    },
    {
      caption: 'Ends With',
      key: 'endsWith',
    },
    {
      caption: 'Not Ends With',
      key: 'nendsWith',
    },
    {
      caption: 'In Range',
      key: 'in',
    },
    {
      caption: 'Not In Range',
      key: 'nin',
    },
    {
      caption: 'And',
      key: 'and',
    },
    {
      caption: 'Or',
      key: 'or',
    },
  ];

  ngOnInit() {
    this.operatorsFiltred = this.operators
      ? this.operators
          .map((operatorName) => {
            return this._operators.find((x) => {
              return x.key === operatorName;
            });
          })
          .filter((operator): operator is QueryOperator => {
            return operator !== undefined;
          })
      : this._operators;

    if (this.defaultOperator) {
      this.operatorValue = this.defaultOperator;
    }
  }

  onRadioChange() {
    this.operatorSelect.emit(this.operatorValue);
  }
}

type QueryOperator = {
  caption: string;
  key: QueryOperatorTypeString;
};
